import { imprimirOuBaixarPdf } from '../../../../../shared/helpers/impressao-navegador.helper';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FatDoctoCCce } from 'app/shared/interfaces/fat-docto-cc-ce';
import { FatDoctoRef } from 'app/shared/interfaces/fat-docto-ref';
import { PageResult } from 'app/shared/interfaces/page-result';
import { FatDoctoCCService } from 'app/shared/services/fat-docto-cc.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { LancamentoCCPopupComponent } from '../lancamento-cc-popup/lancamento-cc-popup.component';
import { LancamentoReferPopupComponent } from '../lancamento-refer-popup/lancamento-refer-popup.component';
import * as FileSaver from 'file-saver';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';

@Component({
  selector: 'app-lancamento-cc',
  templateUrl: 'lancamento-cc.component.html',
  styleUrls: ['lancamento-cc.component.scss'],
})
export class LancamentoCCComponent implements OnInit, OnDestroy {

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;
  cartaCorrecoes: FatDoctoCCce[];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  pageObject$: BehaviorSubject<PageResult<FatDoctoCCce>> = new BehaviorSubject<PageResult<FatDoctoCCce>>(null);
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  view = 'module';
  page = 1;
  length = 0;
  pageSize = 10;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  public searchInput = '';
  searchEntry$: Subject<string> = new Subject<string>();


  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoCCComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCCService,
    private loader: AppLoaderService,
  ) {
  }

  ngOnInit() {
    console.log('INIT ref');
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;


    // inicializa paginator com valores retoRnados pela API.
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
        } else {
        }
      });
    // retorna primeira página da pesquisa.
    this.getPage(1, this.pageSize);

    this.debounceTimeSearch();
  }

  /**
  * Retorna a página requerida,
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getPage(page: number, pageSize: number) {
    this.fatDoctoCService.getPageFatDoctoCCce(this.lcto?.controle, page, pageSize, this.selectedOrdem
      , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
  }

  /**
  * Retorna a página da pesquisa,
  * @param search valor a ser pesquisada
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getSearchPage(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      this.fatDoctoCService.getPageSearchFatDoctoCCce(search, this.lcto?.controle, page, pageSize, this.selectedOrdem
        , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
    }
  }


  /**
   *
   * @param event Captura evento de mudança em alguma configuração no paginator e recarrega a lista.
   */
  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    if (this.searchInput.length > 0) {
      this.getSearchPage(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPage(event.pageIndex + 1, event.pageSize);
    }
  }

  searchBy_UsingDebounce(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearch() {
    this.searchEntry$
      .pipe(debounceTime(500))
      .subscribe((s) => this.getSearchPage(s, 1, this.pageSize));
  }

  private viewSize() {
    if (this.view === 'comfy') {
      return 20;
    } else if (this.view === 'module') {
      return 30;
    }
    return 100;
  }

  ngOnDestroy() {
  }

  createDoctoCC(lcto: FatDoctoC) {
    this.fatDoctoCService.createFatDoctoCCce().subscribe(ref => {
      ref.uuid = '';
      this.editDoctoCC(ref, lcto);
    }, err => {
      this.confirmService.confirm(
        {
          title: `A T E N Ç Ã O !`,
          message: `Não foi Possível criar Carta correção!\n ` + err,
          error: true
        }
      );
    })
  }

  private editDoctoCC(ref: FatDoctoCCce, lcto: FatDoctoC) {
    ref.controle = lcto?.controle;
    let title = "Carta de Correção: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoCCPopupComponent, {
      width: '80%',
      disableClose: true,
      data: { title: title + "[ " + (lcto?.controle ?? '') + " - " + (lcto?.nome ?? '') + " ]", payload: ref }
    });
    dialogRef.afterClosed()
      .subscribe(res => {
        this.getPage(1, this.pageSize);
        if (!res) {
          return;
        }
      });
  }

  delete(ref: FatDoctoCCce) {
    this.confirmService.confirm({ message: `Deseja realmente excluir  [${ref?.correcao}]?` })
      .subscribe(res => {
        if (res) {
          this.fatDoctoCService.deleteFatDoctoCCce(ref?.id).subscribe(s => {
            this.confirmService.confirm(
              {
                title: `S U C E S S O  !`,
                message: `Carta correção excluído com Sucesso !`,
                error: false
              }
            );
            this.getPage(1, this.pageSize);
          },
            (err) => {
              this.confirmService.confirm(
                {
                  title: `A T E N Ç Ã O !`,
                  message: `${err?.error.erro ?? 'Erro ao excluir Carta correção'}`,
                  error: true
                }
              );
            });
        }
      });
  }

  processar(lcto: FatDoctoC, ref: FatDoctoCCce) {
    console.log('Processar', lcto.controle, ref?.id);
    this.confirmService.confirm({ message: `Confirma Processamento ?` })
      .subscribe(res => {
        if (res) {
          this.fatDoctoCService.processarCC(lcto.controle, ref?.id).subscribe(processo => {
            console.log('Processar>>>>>', processo.xmlDistribuicao);
            this.getPage(1, this.pageSize);
            this.confirmService.confirm(
              {
                title: `S U C E S S O !`,
                message: `Carta correção processada com Sucesso ! ${processo.xmlDistribuicao}` ,
                error: false
              }
            );
          },
            (err) => {
              this.confirmService.confirm(
                {
                  title: `A T E N Ç Ã O !`,
                  message: `${err?.error.erro ?? 'Erro ao processar Carta correção'}`,
                  error: true
                }
              );
            });
        }
      });
  }

  downloadPdf(id: number) {
    this.loader.open();
    this.fatDoctoCService.pdfCarta(id).subscribe((response) => {
      const fileToSave = new Blob([response], { type: 'application/pdf' });
      imprimirOuBaixarPdf(fileToSave, `cata-correcao-${id.toString().trim()}.pdf`);
      this.loader.close();
    }, err => {
      this.loader.close();
      const response = JSON.parse(new TextDecoder().decode(err.error));
      this.confirmService.confirm({
        title: 'ERRO AO BAIXAR PDF',
        message: response.status, error: true
      });
    });
  }

  close() {
    this.dialogRef.close();
  }

}
